import { useEffect, useState } from 'react';

const eventName = 'suitestream-device-admin-response';
const storageKey = (id) => `suitestream-device-admin-response-${id}`;
const startupStorageKey = (id) => `suitestream-turn-screen-on-response-${id}`;
const parseObject = (value) => {
  if (typeof value === 'object' && value) return value;
  try { return JSON.parse(value) || {}; } catch { return {}; }
};

export function rememberDeviceAdminResponse(deviceId, response) {
  sessionStorage.setItem(storageKey(deviceId), JSON.stringify(response));
  window.dispatchEvent(new Event(eventName));
}

export function rememberNativeStartupResponse(deviceId, response) {
  sessionStorage.setItem(startupStorageKey(deviceId), JSON.stringify(response));
  window.dispatchEvent(new Event(eventName));
}

export function useDeviceAdminResponses() {
  const [, refresh] = useState(0);
  useEffect(() => {
    const update = () => refresh((value) => value + 1);
    window.addEventListener(eventName, update);
    return () => window.removeEventListener(eventName, update);
  }, []);
}

export function devicePowerPolicy(device) {
  const integration = parseObject(device?.integration_data || device?.integrationData);
  return device?.powerPolicy || integration.appNode?.powerPolicy;
}

export function nativeStandbyPermission(device, liveState) {
  const integration = parseObject(device?.integration_data || device?.integrationData);
  const appNode = integration.appNode || {};
  const live = liveState?.state?.externalApp || liveState?.state || {};
  const policy = live.powerPolicy || devicePowerPolicy(device);
  const item = policy?.items?.find((entry) => entry.key === 'native_standby_admin');
  const capabilities = live.bridgeCapabilities || device?.bridgeCapabilities || appNode.bridgeCapabilities || {};
  const response = parseObject(sessionStorage.getItem(storageKey(device?.id)));
  if (item?.value === 1) return 'enabled';
  // A failed launch with promptOpened:false proves the consent activity could not open.
  // A missing/failed response alone does not establish firmware support.
  if (item?.supported === false || item?.status === 'unsupported' || capabilities.nativeStandbySetup === false
    || (response.success === false && (response.supported === false || (response.promptOpened === false && response.supported !== true)))) return 'unsupported';
  if (item?.value === 0) return 'disabled';
  if (capabilities.nativeStandby === true) return 'enabled';
  return 'unknown';
}

export function nativeStartupPermission(device, liveState) {
  const live = liveState?.state?.externalApp || liveState?.state || {};
  const item = (live.powerPolicy || devicePowerPolicy(device))?.items?.find((entry) => entry.key === 'native_startup_screen_on');
  if (item?.value === 1) return 'enabled';
  if (item?.supported === false || item?.status === 'unsupported') return 'unsupported';
  if (item?.value === 0) return 'disabled';
  const response = parseObject(sessionStorage.getItem(startupStorageKey(device?.id)));
  if (response.permissionGranted === true) return 'enabled';
  if (response.permissionGranted === false) return 'disabled';
  return 'unknown';
}

export function nativePowerPermissionLabel(state) {
  return state === 'enabled' ? 'Active' : state === 'disabled' ? 'Unavailable · permission needed'
    : state === 'unsupported' ? 'Unsupported' : 'Unavailable · not reported';
}
